// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"_2oRPIDizaLB0TE1PeEcE6B","container":"_3OZthAHgJ0wfXGb9OHZVLZ","headline":"_1B9diHzQaZJz9sXOQm8y_v","cta":"_16605VLdoSDFnkuxzhjXrZ"};